/* SickFlash Rewind — letter animation + project brief form */
(function () {
  function splitLetters(root) {
    (root || document).querySelectorAll('[data-split]:not([data-split-done])').forEach(function (el) {
      el.setAttribute('data-split-done', '');
      el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (word) {
              if (!word) return;
              if (/^\s+$/.test(word)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
              word.split('').forEach(function (ch) {
                var l = document.createElement('span'); l.className = 'l'; l.textContent = ch;
                l.style.animationDelay = (i++ * 0.03) + 's'; w.appendChild(l);
              });
              frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1) { walk(n); }
        });
      })(el);
    });
  }

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initProject(root) {
    var form = root.querySelector('form.rw-form');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var cfgEl = root.querySelector('[data-rw="config"]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    function q(name) { return root.querySelector('[data-rw="' + name + '"]'); }

    var OFFERS = cfg.offers || [];
    var CARDS = cfg.cards || [];
    var CHIPS = (cfg.chips || []).map(function (x) { return x.trim(); }).filter(Boolean);
    var PLACES = (cfg.places || []).map(function (x) { return x.trim(); }).filter(Boolean);
    var SIZES = [{ id: 'S', sub: 'under 8 cm' }, { id: 'M', sub: '8–15 cm' }, { id: 'L', sub: '15–25 cm' }, { id: 'XL', sub: '25 cm +' }];
    var INKS = [
      { id: 'Black & grey', sub: 'Shading, no color', sw: '#3A3A3A' },
      { id: 'Black & red', sub: 'One bold accent', sw: '#D3412F' },
      { id: 'Full color', sub: 'The whole palette', sw: '#D8E043' }
    ];
    var FIRSTS = ['Yes, my first!', 'No, I have some'];

    var params = new URLSearchParams(location.search);
    var pre = parseInt(params.get('offer'), 10);
    var S = { offer: cfg.selected, styles: [], place: null, size: null, ink: null, first: null };
    if (pre && OFFERS[pre - 1]) S.offer = OFFERS[pre - 1].id;
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-rw-slot]'));
    var thumbs = [];

    function offer() { return OFFERS.filter(function (o) { return o.id === S.offer; })[0] || OFFERS[0]; }

    function renderOffers() {
      q('offers').innerHTML = OFFERS.map(function (o) {
        return '<button type="button" class="pp-offer" data-offer="' + o.id + '" aria-pressed="' + (S.offer === o.id) + '"' + (o.available ? '' : ' disabled') + '>' +
          '<span class="pp-offer-head"><b>' + esc(o.name) + '</b><span>' + esc(o.price) + '</span></span>' +
          '<span class="pp-offer-list">' + o.lines.map(function (l) { return '<span>★ ' + esc(l) + '</span>'; }).join('') + '</span></button>';
      }).join('');
    }
    function renderStyles() {
      var full = S.styles.length >= 3;
      q('style-cards').innerHTML = CARDS.map(function (c) {
        var on = S.styles.indexOf(c.label) > -1;
        return '<button type="button" class="pp-card-btn" data-style="' + esc(c.label) + '" aria-pressed="' + on + '"' + (full && !on ? ' disabled' : '') + '>' +
          '<img src="' + esc(c.img) + '" alt="' + esc(c.label) + ' tattoo example" loading="lazy">' +
          '<span class="pp-card-row"><b>' + esc(c.label) + '</b><span class="pp-tag">' + (on ? 'Picked ✓' : 'Pick') + '</span></span></button>';
      }).join('');
      q('style-chips').innerHTML = CHIPS.map(function (l) {
        var on = S.styles.indexOf(l) > -1;
        return '<button type="button" class="pp-chip" data-style="' + esc(l) + '" aria-pressed="' + on + '"' + (full && !on ? ' disabled' : '') + '>' + esc(l) + '</button>';
      }).join('');
      q('style-count').textContent = S.styles.length;
    }
    function renderSingles() {
      q('places').innerHTML = PLACES.map(function (p) { return '<button type="button" class="pp-chip" data-place="' + esc(p) + '" aria-pressed="' + (S.place === p) + '">' + esc(p) + '</button>'; }).join('');
      q('sizes').innerHTML = SIZES.map(function (z) { return '<button type="button" class="pp-size" data-size="' + z.id + '" aria-pressed="' + (S.size === z.id) + '"><b>' + z.id + '</b><span>' + z.sub + '</span></button>'; }).join('');
      q('inks').innerHTML = INKS.map(function (k) { return '<button type="button" class="pp-ink" data-ink="' + esc(k.id) + '" aria-pressed="' + (S.ink === k.id) + '"><i style="background:' + k.sw + '"></i><span><b>' + esc(k.id) + '</b><small>' + k.sub + '</small></span></button>'; }).join('');
      q('firsts').innerHTML = FIRSTS.map(function (f) { return '<button type="button" class="pp-chip" data-first="' + esc(f) + '" aria-pressed="' + (S.first === f) + '">' + esc(f) + '</button>'; }).join('');
    }
    function renderThumbs() {
      q('thumbs').innerHTML = thumbs.map(function (t, i) {
        return '<figure><img src="' + t.url + '" alt="Reference ' + (i + 1) + '"><button type="button" data-remove="' + i + '" aria-label="Remove reference ' + (i + 1) + '">×</button></figure>';
      }).join('');
    }
    function syncSlots() {
      // put each chosen file into its own named input so Shopify attaches it to the order
      slots.forEach(function (input, i) {
        var dt = new DataTransfer();
        if (thumbs[i]) dt.items.add(thumbs[i].file);
        input.files = dt.files;
      });
    }
    function summary() {
      var o = offer();
      var link = q('link').value.trim();
      var mailOk = /.+@.+\..+/.test(q('mail').value.trim());
      q('variant').value = o.id;
      q('out-style').value = S.styles.join(', ');
      q('out-place').value = S.place || '';
      q('out-size').value = S.size ? S.size + ' · ' + SIZES.filter(function (z) { return z.id === S.size; })[0].sub : '';
      q('out-ink').value = S.ink || '';
      q('out-first').value = S.first || '';
      q('sum-name').textContent = o.name;
      q('sum-price').textContent = o.price;
      q('sum-style').textContent = S.styles.length ? S.styles.join(', ') : '—';
      q('sum-place').textContent = S.place || '—';
      q('sum-size').textContent = q('out-size').value || '—';
      q('sum-ink').textContent = S.ink || '—';
      q('sum-refs').textContent = thumbs.length ? thumbs.length + ' image' + (thumbs.length > 1 ? 's' : '') + (link ? ' + link' : '') : (link ? 'Link' : '—');
      q('sum-delay').textContent = o.delay || '—';
      q('sum-rounds').textContent = o.rounds || '—';
      if (!q('pay').disabled) q('pay').innerHTML = 'Pay ' + esc(o.price) + ' &amp; start →';
      var steps = [true, q('idea').value.trim().length > 0, S.styles.length > 0, !!(S.place && S.size), !!S.ink, thumbs.length > 0 || link.length > 0, mailOk];
      var done = steps.filter(Boolean).length;
      q('progress').innerHTML = steps.map(function (d) { return '<span style="height:20px;border:2.5px solid #151515;border-radius:6px;background:' + (d ? 'var(--violet)' : '#FFFFFF') + '"></span>'; }).join('');
      q('progress-label').textContent = done + ' / 7';
      var err = q('error');
      if (!err.hidden && steps[1] && steps[2] && steps[6]) err.hidden = true;
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || b.disabled || b.type === 'submit') return;
      if (b.dataset.offer) { S.offer = parseInt(b.dataset.offer, 10); renderOffers(); }
      else if (b.dataset.style) {
        var l = b.dataset.style, i = S.styles.indexOf(l);
        if (i > -1) S.styles.splice(i, 1); else if (S.styles.length < 3) S.styles.push(l);
        renderStyles();
      }
      else if (b.dataset.place) { S.place = b.dataset.place; renderSingles(); }
      else if (b.dataset.size) { S.size = b.dataset.size; renderSingles(); }
      else if (b.dataset.ink) { S.ink = b.dataset.ink; renderSingles(); }
      else if (b.dataset.first) { S.first = b.dataset.first; renderSingles(); }
      else if (b.dataset.remove) { thumbs.splice(+b.dataset.remove, 1); syncSlots(); renderThumbs(); }
      else return;
      summary();
    });
    ['idea', 'mail', 'link'].forEach(function (k) { q(k).addEventListener('input', summary); });

    function addFiles(list) {
      Array.prototype.slice.call(list).forEach(function (f) {
        if (thumbs.length >= slots.length || !/^image\//.test(f.type)) return;
        thumbs.push({ file: f, url: URL.createObjectURL(f) });
      });
      syncSlots(); renderThumbs(); summary();
    }
    q('picker').addEventListener('change', function (e) { addFiles(e.target.files); e.target.value = ''; });
    var drop = q('drop');
    ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files); });

    form.addEventListener('submit', function (e) {
      var missing = [], first = null;
      root.querySelectorAll('.pp-flag').forEach(function (n) { n.classList.remove('pp-flag'); });
      if (!q('idea').value.trim()) { missing.push('describe your idea'); first = first || 'idea'; }
      if (!S.styles.length) { missing.push('pick at least one style'); first = first || 'style'; }
      if (!/.+@.+\..+/.test(q('mail').value.trim())) { missing.push('add your email'); first = first || 'you'; }
      if (missing.length) {
        e.preventDefault();
        var err = q('error');
        err.textContent = 'Almost there: ' + missing.join(', ') + '.';
        err.hidden = false;
        var step = root.querySelector('[data-rw-step="' + first + '"]');
        step.classList.add('pp-flag'); step.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      summary();
      // leave blank answers out of the order so it only shows what the client filled in
      form.querySelectorAll('[name^="properties["]').forEach(function (f) {
        if (f.type !== 'file' && !String(f.value).trim()) f.disabled = true;
      });
      window.addEventListener('pageshow', function () {
        form.querySelectorAll('[name^="properties["]:disabled').forEach(function (f) { f.disabled = false; });
        q('pay').disabled = false; summary();
      }, { once: true });
      q('pay').disabled = true;
      q('pay').textContent = 'Opening secure checkout…';
    });

    renderOffers(); renderStyles(); renderSingles(); summary();
  }

  function boot() {
    splitLetters();
    document.querySelectorAll('[data-rw-project]').forEach(initProject);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
